import { LinearProgress, linearProgressClasses, LinearProgressProps, styled } from '@mui/material';
import React from 'react';

const LinearProgressBar = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[400],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main,
  },
}));
export interface ProgressBarProps extends LinearProgressProps {
  stepsProgress?: number;
}
/**
 * Atomic component progress bar.
 *
 * @param {number} stepsProgress - The current step count value for the progress bar.
 *
 * @returns {JSX.Element} The rendered ProgressBar component.
 */
export const ProgressBar = ({
  stepsProgress = 0,
  variant = 'determinate',
  ...rest
}: ProgressBarProps) => (
  /* MUIdo not play nice with display:'flex' so we need flexGrow:1 */
  <LinearProgressBar
    variant={variant}
    value={stepsProgress}
    {...rest}
    sx={{ flexGrow: 1, ...rest.sx }}
  />
);
